import axios from 'axios'
import store from '../store'
import router from '../router'
import {
  Loading,
  Message
} from 'element-ui'

let loading = '';
axios.interceptors.request.use(config => { // 请求之前(可以设置token)
  if (!config.headers.hideLoading) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  if (!config.headers.Authorization && !config.headers.noCheck) {
    config.headers.Authorization = store.state.token;
  }
  console.log(config, "config");
  return config
}, error => {
  return Promise.reject(error);
});
axios.interceptors.response.use(response => { // 数据拿到之后
  loading.close();
  if (!response.data.code || response.data.code == 0) {
    return response.data
  } else {
    Message({
      message: response.data.msg,
      type: "error"
    });
    return Promise.reject(response.data);
  }
}, error => {
  loading.close();
  return Promise.reject(error.response);
});

function successfun(res) { // 处理后台返回的非200错误
  return res;
}

function errorfun(res) {
  if (res.code == 40005) {
    // 登录失效，返回登录页面
    store.commit('loginOut');
    router.replace({
      name: 'login'
    })
  }
  if (res.status == 500 || res.status == 501 || res.status == 502 || res.status == 503 || res.status == 504 || res.status == 505) {
    // router.replace({
    //   name: '500'
    // })
    Message({
      message: res.statusText,
      type: "error"
    });
  }
  return Promise.reject(res.data);
}

function request(method, params = {}) {
  return axios(Object.assign({
    method,
    withCredentials: true,
    timeout: 2000000000 // 响应时间
  }, params)).then(res => {
    return successfun(res)
  }, err => {
    return errorfun(err);
  })
}
export default {
  post(url, data, headers) { // post请求
    return request("post", {
      data,
      url,
      headers
    })
  },
  put(url, data, headers) { // put请求
    return request("put", {
      data,
      url,
      headers
    })
  },
  delete(url, params) { // delete请求
    return request("delete", {
      url,
      params
    })
  },
  get(url, params, headers) { // get请求
    return request("get", {
      url,
      params,
      headers
    })
  }
}
